import Image from 'next/image'
import Link from 'next/link'
import { useRef, useState } from 'react'
import Button from '~/src/components/Button'

interface Props {
  onClickCallback?: () => void
}

const ExtensionModalContent: React.FC<Props> = ({ onClickCallback }) => {
  const [videoPlaying, setVideoPlaying] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)

  const playVideo = () => {
    if (videoPlaying) return

    if (videoRef.current) {
      videoRef.current.play()
      setVideoPlaying(true)
    }
  }

  return (
    <div className='bg-bellblue flex items-center px-6 py-8 text-black md:px-16 md:py-24'>
      <div className='relative hidden w-2/5 md:block md:pr-8'>
        <video
          ref={videoRef}
          src='https://ik.imagekit.io/carrot/dupe_com/dupe_desktop_extension_promo_SL-CPTJbP.mp4?updatedAt=1716491368350'
          poster='/assets/modal-extension/video-preview.png'
          className='aspect-[9/16] rounded-2xl object-contain'
          playsInline
          controls={videoPlaying}
        />
        {!videoPlaying && (
          <button
            onClick={playVideo}
            className='absolute inset-0 flex items-center justify-center'
          >
            <Image
              alt=''
              src='/assets/modal-extension/video-preview-play.png'
              width={128}
              height={128}
              className='h-12 w-12'
            />
          </button>
        )}
      </div>
      <Link
        href='https://chromewebstore.google.com/detail/dupe/pkhpcfoaocmmpmphhenoblggeinedlah'
        target='_blank'
        className='space-y-8 md:w-3/5'
        onClick={() => {
          if (onClickCallback) {
            onClickCallback()
          }
        }}
      >
        <div className='md:space-y-4'>
          {/* <div className='font-cta uppercase'>Daily limit reached</div> */}
          <div className='text-2xl font-bold md:text-5xl'>
            Get results 10x faster with our <em>free</em> plugin
          </div>
          <div className='text-lg font-semibold md:text-4xl'>
            Enable in two clicks.
          </div>
        </div>
        <div className='w-full space-y-8'>
          <Button variant='action' size='lg' className='w-full max-w-md'>
            <div>
              <span className='hidden md:block'>Add to Chrome — it’s free</span>
              <span className='md:hidden'>Add to Chrome</span>
            </div>
          </Button>
          <div>
            <Image
              src='/assets/modal-extension/fluff.png?v=1'
              alt=''
              width={465}
              height={78}
            />
          </div>
        </div>
      </Link>
    </div>
  )
}

export default ExtensionModalContent
